import { ServicesPageDefault } from 'src/components/features';

const ServicesPage = () => {
	return <ServicesPageDefault />;
};

export default ServicesPage;